module.exports = __webpack_public_path__ + "img/loans.2f8d62cd.svg";